import { t } from '@bms2/shared';
import wordmark from './wordmark.webp';
import wordmarkFallback from './wordmark.png';
import styles from './shell.module.css';

/**
 * The brand's wordmark (piece 12): the mark the product owner supplied on
 * 2026-09-09, cropped from the specification's own title block and shipped
 * as the file itself. 🔨 The header draws the file and never a redrawing of
 * it. 💰 A vector redrawing in the brand's typeface stood here first, and
 * the product owner refused it the same day: the logo is the file, not a
 * likeness (found while building, 2026-09-09).
 */
export function Wordmark() {
  return (
    <picture className={styles.wordmark} data-shell="wordmark">
      <source srcSet={wordmark} type="image/webp" />
      <img src={wordmarkFallback} alt={t('shell.productName')} className={styles.wordmarkImage} />
    </picture>
  );
}
